import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=62cc5359&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "./sign.vue?vue&type=style&index=0&id=62cc5359&prod&lang=less&scoped=true&"
import style1 from "./sign.vue?vue&type=style&index=1&id=62cc5359&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc5359",
  null
  
)

export default component.exports